import {
  ErrorOutline24Icon,
  ErrorOutline30Icon,
  LinkOutOutline18Icon,
} from "@vygruppen/spor-icon-react";
import { criticalErrorMailLink } from "features/Header/Menu/adminLinks/MailLink";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ErrorStateIllustration from "shared/components/illustrations/errorStateIllustration.svg?react";
import { Button, Flex, Text } from "shared/components/Spor";
import { SectionStateContentSize } from "shared/components/states/SectionStateContent";
import { StateContentContainer } from "shared/components/states/StateContentContainer";
import colors from "shared/theme/colors";
import styled from "styled-components";

const CriticalErrorButton = styled(Button)`
  background-color: ${colors.apricot};
  &:hover {
    opacity: 0.8;
  }
`;

type ErrorProps = {
  backgroundColor?: string;
  size?: SectionStateContentSize;
  onRetry?: () => void;
};

const Content = ({
  size,
  onRetry,
}: {
  size: SectionStateContentSize;
  onRetry?: () => void;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      void navigate(0);
    }
  };

  if (size === "sm") {
    return (
      <>
        <ErrorOutline24Icon />
        <Text textAlign="center" fontSize="sm">
          Noe gikk galt! Last siden på nytt. Ev. kontakt Team Drops.
        </Text>
      </>
    );
  }

  if (size === "lg") {
    return (
      <>
        <ErrorStateIllustration height={160} width={180} />
        <Text my={0} textAlign="center" fontSize="md">
          Noe gikk galt! Last siden på nytt for å prøve igjen. Dersom feilen
          vedvarer, ta kontakt med team DROPS.
        </Text>
        <Flex gap="2" justifyContent="center">
          <CriticalErrorButton
            semantic="alarm"
            size="md"
            rightIcon={<LinkOutOutline18Icon mb="3px" />}
          >
            <a
              href={criticalErrorMailLink(t)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Kritisk feil")}
            </a>
          </CriticalErrorButton>

          <Button size="md" variant="primary" onClick={handleRetry}>
            {t("Last på nytt")}
          </Button>
        </Flex>
      </>
    );
  }

  return (
    <>
      <ErrorOutline30Icon />
      <Text textAlign="center" fontSize="sm">
        Noe gikk galt! Last siden på nytt. Om feilen vedvarer, kontakt team
        DROPS via tilbakemeldingsknappene.
      </Text>

      <Button size="md" variant="primary" onClick={handleRetry}>
        {t("Last på nytt")}
      </Button>
    </>
  );
};

export const ErrorContent = ({
  backgroundColor,
  size = "md",
  onRetry,
}: ErrorProps) => (
  <StateContentContainer size={size} backgroundColor={backgroundColor}>
    <Content size={size} onRetry={onRetry} />
  </StateContentContainer>
);
